export default "__VITE_ASSET__x6lW$9sx__"